import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6379eaaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-list-view-media item-image" }
const _hoisted_2 = { class: "level-center is-mobile" }
const _hoisted_3 = ["src", "onerror", "id", "alt"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "item-body" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "item-list-view-content-content-title has-text-table-cell-title"
}
const _hoisted_8 = { class: "item-list-view-detail" }
const _hoisted_9 = { class: "item-list-view-detail-collection has-text-modest has-text-weight-bold" }
const _hoisted_10 = { class: "item-list-view-detail-content" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "tag-list-view" }
const _hoisted_13 = { class: "tag-list" }
const _hoisted_14 = {
  key: 0,
  class: "tag-item"
}
const _hoisted_15 = {
  key: 0,
  class: "tag-item"
}
const _hoisted_16 = { class: "item-list-view-info show-mobile" }
const _hoisted_17 = { class: "item-list-view-tools has-text-link level is-mobile" }
const _hoisted_18 = { class: "item-list-view-rights" }
const _hoisted_19 = { class: "icon-area" }
const _hoisted_20 = { class: "item-list-view-permission-text" }
const _hoisted_21 = {
  key: 0,
  class: "collection-list-wrap"
}
const _hoisted_22 = {
  key: 0,
  class: "collection-detailed-search-body"
}
const _hoisted_23 = { class: "collection-list" }
const _hoisted_24 = { class: "item-list-view has-background-contents" }
const _hoisted_25 = { class: "item-list-view-media" }
const _hoisted_26 = { class: "has-background-modest level-center is-mobile" }
const _hoisted_27 = ["id", "src"]
const _hoisted_28 = { class: "item-list-view-content" }
const _hoisted_29 = { class: "item-list-view-content-title has-text-table-cell-title" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ":", -1))
const _hoisted_31 = { class: "content-name" }
const _hoisted_32 = { class: "item-list-view-info" }
const _hoisted_33 = { class: "item-list-view-tools has-text-link level is-mobile" }
const _hoisted_34 = { class: "item-list-view-info show-desktop" }
const _hoisted_35 = { class: "item-list-view-tools has-text-link level is-mobile" }
const _hoisted_36 = { class: "item-list-view-rights" }
const _hoisted_37 = { class: "icon-area" }
const _hoisted_38 = { class: "item-list-view-permission-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CollectionDropdown = _resolveComponent("CollectionDropdown")!
  const _component_AppTag = _resolveComponent("AppTag")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_AppIconPlaces = _resolveComponent("AppIconPlaces")!
  const _component_AppLabelPlaces = _resolveComponent("AppLabelPlaces")!
  const _component_CloserController = _resolveComponent("CloserController")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: _normalizeClass(["item-list-view has-background-contents", `${_ctx.displayMode}-view`])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_AppCheckbox, {
          id: `multiple-add-tag-${_ctx.itemIndex}`,
          checkBoxName: 'multiple-add-tag',
          value: _ctx.item.pid,
          "aria-label": _ctx.checkBoxAriaLabel,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTagSelected()))
        }, null, 8, ["id", "value", "aria-label"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: _ctx.thumbnailLink(_ctx.item)
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", _hoisted_2, [
              (_ctx.item.thumbnail && _ctx.hasThumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.BASE_URL + _ctx.item.thumbnail,
                    onerror: _ctx.notThumbnail,
                    id: 'the-item-list-thumbnail-' + _ctx.itemIndex,
                    alt: _ctx.$t('rightPane.thumbnailAlt')
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createBlock(_component_PlaceholderImage, {
                    key: 1,
                    type: _ctx.placeholderType,
                    id: 'the-item-list-icon-'+_ctx.itemIndex
                  }, null, 8, ["type", "id"]))
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", {
        id: 'item-list-view-content-'+_ctx.itemIndex,
        class: "item-list-view-content"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", {
            class: _normalizeClass(["item-list-view-content-title has-text-table-cell-title", {'sub-title' : _ctx.item.contentsNumber}]),
            id: 'item-list-view-content-title'+_ctx.itemIndex
          }, [
            _createVNode(_component_router_link, {
              to: `/pid/${_ctx.item.pid}`,
              class: "item-label level-left is-mobile"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "prefix", {}, undefined, true),
                _createElementVNode("span", null, _toDisplayString(_ctx.itemListViewTitle), 1)
              ]),
              _: 3
            }, 8, ["to"])
          ], 10, _hoisted_6),
          (_ctx.item.contentsNumber)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: `/pid/${_ctx.item.contentLink}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.item.contentsNumber), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("span", null, ": " + _toDisplayString(_ctx.item.contentTitle), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.itemListViewCollection), 1),
            _createElementVNode("p", _hoisted_10, [
              _createElementVNode("span", { innerHTML: _ctx.itemListViewContent }, null, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              (_ctx.item.tagIds.length <= 1)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                    _createVNode(_component_CollectionDropdown, {
                      pid: _ctx.item.pid,
                      styled: 'is-none',
                      selectedTag: _ctx.displayTagList
                    }, null, 8, ["pid", "selectedTag"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTagList, (tagId, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "tag-item",
                        key: `displayTagList_${_ctx.item.pid}-${index}`
                      }, [
                        _createVNode(_component_AppTag, {
                          tag: 'span',
                          text: _ctx.getTagText(tagId),
                          removable: true,
                          onRemove: ($event: any) => (_ctx.onUnlink(tagId))
                        }, null, 8, ["text", "onRemove"])
                      ]))
                    }), 128)),
                    (_ctx.item.tagIds.length <= 50)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                          _createVNode(_component_CollectionDropdown, {
                            pid: _ctx.item.pid,
                            selectedTag: _ctx.displayTagList
                          }, null, 8, ["pid", "selectedTag"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_ButtonIcon, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.bookmarkItem({
              pid: _ctx.item.pid,
              bid: null,
              cid: null
            }))),
              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.bookmarkItem({
              pid: _ctx.item.pid,
              bid: null,
              cid: null
            })), ["prevent"]), ["space","enter"])),
              icon: 'bookmark-fill',
              styled: "is-none",
              class: "button-bookmark",
              "aria-label": _ctx.$t('mycollection.bookmarkToRemove')
            }, null, 8, ["aria-label"]),
            _renderSlot(_ctx.$slots, "tools", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_AppIconPlaces, { type: _ctx.permissionRule }, null, 8, ["type"])
                ]),
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.permissionText), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ])
        ]),
        (_ctx.contentList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_CloserController, {
                modelValue: _ctx.showContents,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showContents) = $event)),
                text: _ctx.contentList.length + _ctx.$t('label.case'),
                class: "has-text-forms-normal"
              }, null, 8, ["modelValue", "text"]),
              (_ctx.showContents)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentList, (content, contentIndex) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "collection-item",
                          key: `content_${_ctx.item.pid}_${contentIndex}`
                        }, [
                          _createElementVNode("article", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("figure", _hoisted_26, [
                                (content.publicPath && _ctx.hasThumbnail)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      id: `the-item-list-thumbnail-${_ctx.item.pid}-${contentIndex}`,
                                      src: `${_ctx.BASE_URL}${content.publicPath}`,
                                      alt: "",
                                      class: "has-background-modest__img"
                                    }, null, 8, _hoisted_27))
                                  : (_openBlock(), _createBlock(_component_PlaceholderImage, {
                                      key: 1,
                                      id: 'the-item-list-icon-'+contentIndex,
                                      type: _ctx.placeholderType['A00001']
                                    }, null, 8, ["id", "type"]))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("h1", _hoisted_29, [
                                _createVNode(_component_router_link, {
                                  to: `/pid/${_ctx.item.pid}/${content.bundleNumber}/${content.contentsNumber}`,
                                  class: "contents-number"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(content.contentsNumber), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _hoisted_30,
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.contentsName(content.name)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_ButtonIcon, {
                                  onClick: ($event: any) => (_ctx.bookmarkItem({
                        pid: _ctx.item.pid,
                        bid: content.bid,
                        cid: content.cid,
                      })),
                                  onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.bookmarkItem({
                        pid: _ctx.item.pid,
                        bid: content.bid,
                        cid: content.cid,
                      })), ["prevent"]), ["space","enter"]),
                                  icon: 'bookmark-fill',
                                  styled: "is-none",
                                  "aria-label": _ctx.$t('mycollection.bookmarkToRemove')
                                }, null, 8, ["onClick", "onKeydown", "aria-label"])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_4),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_ButtonIcon, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bookmarkItem({
            pid: _ctx.item.pid,
            bid: null,
            cid: null
          }))),
            onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.bookmarkItem({
            pid: _ctx.item.pid,
            bid: null,
            cid: null
          })), ["prevent"]), ["space","enter"])),
            icon: 'bookmark-fill',
            styled: "is-none",
            class: "button-bookmark",
            "aria-label": _ctx.$t('mycollection.bookmarkToRemove')
          }, null, 8, ["aria-label"]),
          _renderSlot(_ctx.$slots, "tools", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_AppLabelPlaces, { type: _ctx.permissionColor }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_AppIconPlaces, { type: _ctx.permissionRule }, null, 8, ["type"])
              ]),
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.permissionText), 1)
            ]),
            _: 1
          }, 8, ["type"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}